import { render } from "./Onboard.vue?vue&type=template&id=02f87c20&scoped=true&lang=pug"
import script from "./Onboard.vue?vue&type=script&lang=js"
export * from "./Onboard.vue?vue&type=script&lang=js"

import "./Onboard.vue?vue&type=style&index=0&id=02f87c20&lang=scss"
import "./Onboard.vue?vue&type=style&index=1&id=02f87c20&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f87c20"]])

export default __exports__